import React from 'react';
import RoutesListCard from '../RoutesListCard/RoutesListCard';
import { useTaskRoutesListCard } from './hooks/useTaskRoutesListCard';

type Props = { taskId: number };

const TaskRoutesListCard: React.FC<Props> = ({ taskId }) => {
  const {
    groupedRoutes,
    isFetching,
    isAllRoutesChecked,
    checkedRouteIds,
    onRoutesCheck,
    onToggleAllRoutes,
  } = useTaskRoutesListCard({ taskId });

  return (
    <RoutesListCard
      groupedRoutes={groupedRoutes}
      isLoading={isFetching}
      checkedRouteIds={checkedRouteIds}
      onRoutesCheck={onRoutesCheck}
      onToggleAllRoutes={onToggleAllRoutes}
      isAllRoutesChecked={isAllRoutesChecked}
    />
  );
};

export default TaskRoutesListCard;
